import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/auth/phone.png")